import { Dispatch, SetStateAction } from 'react';
import { DateRange } from 'react-day-picker';
import DateRangePicker from './components/DateRangePicker/DateRangePicker';
import CustomDropdown from './AdministratorDashboard/AdminReportComponents/CustomDropdown/CustomDropdown';
import styles from './ConcerningEmotionsReport.module.scss';

export const ALL = 'all';

interface Props {
  classOptions: { id: string; name: string }[];
  gradeOptions: { id: string; name: string }[];
  selectedClassroomId: string;
  setSelectedClassroomId: (id: string) => void;
  selectedGrade: string;
  setSelectedGrade: (id: string) => void;
  dateRange: DateRange;
  setDateRange: Dispatch<SetStateAction<DateRange>>;
  startOfSchoolYear: Date;
  today: Date;
  isDisplayDayPicker: boolean;
  setIsDisplayDayPicker: Dispatch<SetStateAction<boolean>>;
  isLoading: boolean;
}

const ConcerningEmotionsReportFilters = ({
  classOptions,
  gradeOptions,
  selectedClassroomId,
  setSelectedClassroomId,
  selectedGrade,
  setSelectedGrade,
  dateRange,
  setDateRange,
  startOfSchoolYear,
  today,
  isDisplayDayPicker,
  setIsDisplayDayPicker,
  isLoading,
}: Props): JSX.Element => (
  <div className={styles.filters}>
    <div className={styles.filterItem}>
      <CustomDropdown
        list={classOptions}
        onSelectSubject={(id) => setSelectedClassroomId(id ?? ALL)}
        initialValue={ALL}
        currentlySelectedItem={selectedClassroomId}
        disableChangeLocation={isLoading}
        placeholder='By class'
        noFilter
        className={styles.dropdownText}
      />
    </div>
    <div className={styles.filterItem}>
      <CustomDropdown
        list={gradeOptions}
        onSelectSubject={(id) => setSelectedGrade(id ?? ALL)}
        initialValue={ALL}
        currentlySelectedItem={selectedGrade}
        disableChangeLocation={isLoading}
        placeholder='By grade'
        noFilter
        className={styles.dropdownText}
      />
    </div>
    <div className={styles.dateFilter}>
      <DateRangePicker
        dateRange={dateRange}
        setDateRange={setDateRange}
        startDate={startOfSchoolYear}
        excludeAfter={today}
        beforeFirstInputText='Start Date:'
        beforeSecondInputText='End Date:'
        isDisplayCalendar={isDisplayDayPicker}
        setIsDisplayCalendar={setIsDisplayDayPicker}
      />
    </div>
  </div>
);

export default ConcerningEmotionsReportFilters;
